
export const baseUrl = process.env.REACT_APP_BASE_URL_BACK



//  export const process.env.REACT_APP_API_URL_BACK = 'https://www.websal.com/fdprog/'

// export const baseUrl = 'https://desarrollo.websal.com/rem/api/autoconsulta/'

// export const process.env.REACT_APP_API_URL_BACK = 'http://localhost:8082/'


export const backMfa = 'https://www.websal.com/mfa/'



export const backRemu = process.env.REACT_APP_API_URL_REMUBACK

// http://localhost:8070/